import React from 'react';
import { Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatIcon from '@mui/icons-material/Chat';

const Whatsapp = ({ image, text }) => {

  const handleWhatsAppClick = () => {
    // WhatsApp'ı açmak için bir link oluşturuyoruz
    const link = 'https://wa.me/+358413124969'; // Telefon numaranızı buraya girin
    window.open(link, '_blank');
  };


  return (
    <>
    <Box
      sx={{
        position: 'fixed',
        bottom: '3vh',
        left: '3%', // Sol alt köşe
        zIndex: 1000, // Gerekirse z-index ayarlayabilirsiniz
        cursor: 'pointer', // İkona tıklanabilir şekilde cursor ayarla
      }}
      onClick={handleWhatsAppClick} // WhatsApp simgesine tıklandığında handleWhatsAppClick fonksiyonunu çağırır
    >
      <WhatsAppIcon color='success' sx={{ fontSize:72 }} /> {/* Simgenin boyutunu ayarla */}
    </Box>
    
  </>

  );

};

export default Whatsapp;